module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_01_770_280_ko-d9b4352edd12d7f0a31b9670e2206293.jpg";